import cn from 'classnames';
import isBoolean from 'lodash/isBoolean';
import T from 'prop-types';
import React from 'react';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import text from '../../text';
import Icon from '../icon/Icon';
import { useSelector } from 'react-redux';
import { profileSelectors } from '../../redux/selectors/profile';

const NavLinkContent = ({ icon, isLocked, name, isCollapsed }) => (
  <>
    <div className='nav-left'>
      <div className='nav-icon-container'>
        {icon ? <Icon className='nav-icon' icon={icon} /> : null}
        {isLocked ? <Icon icon='lock' className='original' /> : null}
      </div>
      {text(name)}
    </div>
    <div className='caret-icon'>
      <Icon
        icon={cn({
          'caret-right': !isBoolean(isCollapsed),
          'caret-up': isBoolean(isCollapsed) && isCollapsed,
          'caret-down': isBoolean(isCollapsed) && !isCollapsed,
        })}
      />
    </div>
  </>
);

NavLinkContent.propTypes = {
  icon: T.string,
  isLocked: T.bool,
  name: T.string.isRequired,
  isCollapsed: T.bool,
};

const NavLink = ({
  isCaretHighlighted = true,
  isBorderHighlighted = true,
  className,
  name,
  onClick,
  href = '#',
  isCollapsed,
  icon,
  isLocked = false,
  ...rest
}) => {
  const isUpgradeRecommended = useSelector(
    profileSelectors.getIsUpgradeRecommended
  );
  const view3dTooltipText = isUpgradeRecommended
    ? text('upgradeToView3dTooltip')
    : text('startTrialToView3dTooltip');

  const navLinkProps = {
    className: cn(
      {
        'is-caret-highlighted': isCaretHighlighted,
        'is-border-highlighted': isBorderHighlighted,
        'is-locked': isLocked,
      },
      className
    ),
    href,
    eventKey: name,
    onClick,
    ...rest,
  };

  const navLink = (
    <Nav.Link {...navLinkProps}>
      <NavLinkContent
        icon={icon}
        isLocked={isLocked}
        name={name}
        isCollapsed={isCollapsed}
      />
    </Nav.Link>
  );

  return isLocked ? (
    <OverlayTrigger
      placement='right'
      delay={{ show: 250 }}
      overlay={<Tooltip>{view3dTooltipText}</Tooltip>}
    >
      {navLink}
    </OverlayTrigger>
  ) : (
    navLink
  );
};

NavLink.propTypes = {
  href: T.string,
  name: T.string.isRequired,
  onClick: T.func,
  isCollapsed: T.bool,
  isCaretHighlighted: T.bool,
  isBorderHighlighted: T.bool,
  className: T.string,
  icon: T.string,
  isLocked: T.bool,
};

export default NavLink;
